export default __webpack_public_path__ + "static/media/ni.03e91143.svg";